import React from 'react'

// iconMapping.ts
import {
  InsuranceStatus,
  PatientStatus,
  FormStatus,
  PaymentStatus,
  OtherStatus,
  AppointmentStatus,
} from '@dataTypes/appointment.type' // Adjust the import path as necessary
import {
  alert,
  allergy,
  cancelled,
  completed,
  confirmed,
  criticalAttentsionNeeded,
  followUp,
  formComplete,
  formIncomplete,
  insuranceVerified,
  insuredNotVerified,
  issueWithInsurance,
  late,
  medicalCondition,
  medicalTest,
  newPatient,
  noShow,
  notInsured,
  pendingPayment,
  pending,
  checkin,
  checkout,
  intreatment,
} from '@assets/images/AppointmentIcons'

interface StatusIconMapping {
  [key: string]: (status: number) => JSX.Element | null
}

export const statusIconMapping: StatusIconMapping = {
  appointment_status: (
    status: AppointmentStatus,
  ): React.ReactElement | null => {
    switch (status) {
      case AppointmentStatus.Confirmed:
        return <img src={confirmed} alt="confirmed"></img>
      case AppointmentStatus.Completed:
        return <img src={completed} alt="completed"></img>
      case AppointmentStatus.Alert:
        return <img src={alert} alt="alert"></img>
      case AppointmentStatus.FollowUp:
        return <img src={followUp} alt="followUp"></img>
      case AppointmentStatus.NewPatient:
        return <img src={newPatient} alt="newPatient"></img>
      case AppointmentStatus.Cancelled:
        return <img src={cancelled} alt="cancelled"></img>
      case AppointmentStatus.NoShow:
        return <img src={noShow} alt="noShow"></img>
      case AppointmentStatus.Late:
        return <img src={late} alt="late"></img>
      case AppointmentStatus.Pending:
        return <img src={pending} alt="pending"></img>
      case AppointmentStatus.Unconfirmed:
        return <img src={pending} alt="unconfirmed"></img>
      case AppointmentStatus.CheckIn:
        return <img src={checkin} alt="checkin"></img>
      case AppointmentStatus.CheckOut:
        return <img src={checkout} alt="checkout"></img>
      case AppointmentStatus.InTreatment:
        return <img src={intreatment} alt="intreatment"></img>
      default:
        return null
    }
  },
  insurance_status: (status: InsuranceStatus): React.ReactElement | null => {
    switch (status) {
      case InsuranceStatus.InsuredVerify:
        return <img src={insuranceVerified} alt="insuranceVerified"></img>
      case InsuranceStatus.NotInsured:
        return <img src={notInsured} alt="notInsured"></img>
      case InsuranceStatus.InsuredNotVerified:
        return <img src={insuredNotVerified} alt="insuredNotVerified"></img>
      case InsuranceStatus.InsuranceIssue:
        return <img src={issueWithInsurance} alt="issueWithInsurance"></img>
      default:
        return null
    }
  },
  patient_status: (status: PatientStatus): React.ReactElement | null => {
    switch (status) {
      case PatientStatus.MedicalCondition:
        return <img src={medicalCondition} alt="medicalCondition"></img>
      case PatientStatus.CriticalAttentionNeeded:
        return (
          <img
            src={criticalAttentsionNeeded}
            alt="criticalAttentsionNeeded"
          ></img>
        )
      case PatientStatus.HasAllergy:
        return <img src={allergy} alt="allergy"></img>
      default:
        return null
    }
  },
  form_status: (status: FormStatus): React.ReactElement | null => {
    switch (status) {
      case FormStatus.FormCompleted:
        return <img src={formComplete} alt="formComplete"></img>
      case FormStatus.FormIncomplete:
        return <img src={formIncomplete} alt="formIncomplete"></img>
      default:
        return null
    }
  },
  payment_status: (status: PaymentStatus): React.ReactElement | null => {
    switch (status) {
      case PaymentStatus.PaymentCompleted:
        return <img src={pendingPayment} alt="pendingPayment"></img>
      case PaymentStatus.MissedPayments:
        return <img src={pendingPayment} alt="pendingPayment"></img>
      default:
        return null
    }
  },
  other_status: (status: OtherStatus): React.ReactElement | null => {
    switch (status) {
      case OtherStatus.MedicalTest:
        return <img src={medicalTest} alt="medicalTest"></img>
      default:
        return null
    }
  },
}
